<template>
	<v-card flat>
		<v-fab :key="fabPosition" :absolute="fabPosition === 'absolute'" :app="fabPosition === 'fixed'"
			:color="open ? '' : 'primary'" :location="fabLocation" size="large" icon>
			<v-icon>{{ open ? 'mdi-close' : 'mdi-crown' }}</v-icon>
			<v-speed-dial v-model="open" :location="menuLocation" :transition="transition" activator="parent">
				<v-tooltip v-for="item in items" :key="item.key" :open-on-hover="true">
					<template #activator="{ props }">
						<v-btn v-bind="props" fab :size="fabSize" @click="go(item.to)">
							<v-icon size="28">{{ item.icon }}</v-icon>
						</v-btn>
					</template>
					<span>{{ item.title }}</span>
				</v-tooltip>
			</v-speed-dial>
		</v-fab>
	</v-card>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, shallowRef, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useNavItems } from '@/composables/UseSpeedNav'

// 2025.06.21 - BSU
// Vue complains about the :location binds above, but doesn't expose 'Anchor' type directly.
// type Anchor =
// 	| 'top left' | 'top center' | 'top right'
// 	| 'center left' | 'center center' | 'center right'
// 	| 'bottom left' | 'bottom center' | 'bottom right'
// 	| 'right center' | 'left center'

const open = shallowRef(false)
const fabPosition = shallowRef('absolute') // or 'fixed', 'app'
const fabLocation = shallowRef('center center') // or 'left center', etc
const menuLocation = shallowRef('right center') // or 'left center', etc
const transition = shallowRef('slide-x-transition') // or 'fade-transition', etc
const fabSize = shallowRef('large') // or 'medium', 'small', etc

const router = useRouter()
const items = useNavItems()

function go(to: any) {
	open.value = false
	router.push(to)
}

function onKeydown(e: KeyboardEvent) {
	// Ctrl + Alt + P
	if (e.ctrlKey && e.key.toLowerCase() === 'b') {
		e.preventDefault()
		open.value = !open.value
	}
}

onMounted(() => {
	//window.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
	//window.removeEventListener('keydown', onKeydown)
})
</script>

<style lang="scss" scoped>

</style>
